import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { PlainSwitch } from 'components/Switch';

function Switch(props) {
  const { className, disabled, children, name, defaultValue } = props;

  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => {
        return (
          <PlainSwitch
            className={className}
            name={name}
            defaultValue={defaultValue}
            checked={value}
            inputProps={{
              onChange: ({ target: { checked } }) => onChange(checked),
            }}
            disabled={disabled}>
            {children}
          </PlainSwitch>
        );
      }}
    />
  );
}

Switch.defaultProps = {
  className: '',
  disabled: false,
};

Switch.propTypes = {
  defaultValue: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.func,
};

export default Switch;
